import React from 'react';
import { PurchaseRequestRecord } from '../../../../types/PurchaseRequest';
import { Descriptions } from 'antd';
import StatusTag from '../../../../components/ui/StatusTag';

interface PurchaseRequestInfoViewProps {
  data: PurchaseRequestRecord | undefined;
}
const PurchaseRequestInfoView: React.FC<PurchaseRequestInfoViewProps> = ({
                                                                           data,
                                                                         }) => {
  return (
    <>
      <Descriptions
        title="Purchase Request"
        style={{
          backgroundColor: 'white',
          padding: '16px',
          borderRadius: '0.25rem',
        }}
      >
        <Descriptions.Item label="Code">{data?.code}</Descriptions.Item>
        <Descriptions.Item label="Required Date">
          {data?.requiredDate}
        </Descriptions.Item>
        <Descriptions.Item label="Source Document">
          {data?.source}
        </Descriptions.Item>
        <Descriptions.Item label="Destination">
          {data?.destination?.description}
        </Descriptions.Item>
        <Descriptions.Item label="Requested by">
          {data?.requestedBy || '—'}
        </Descriptions.Item>
        <Descriptions.Item label="Buyer">
          {data?.buyer?.description || '—'}
        </Descriptions.Item>
        <Descriptions.Item label="Date needed">
          {data?.dateNeeded || '—'}
        </Descriptions.Item>
        <Descriptions.Item label="Notes">{data?.notes}</Descriptions.Item>
        <Descriptions.Item label="Status">
          <StatusTag status={data?.status ?? ''} />
        </Descriptions.Item>
      </Descriptions>
    </>
  );
};

export default PurchaseRequestInfoView;
